import { getUserId } from "~/lib/auth.server";
import type { Route } from "./+types/home";
import LandingPage from "./landing";

export function meta() {
  return [
    { title: "Disruptive Futures Platform — by APTIM Solutions" },
    {
      name: "description",
      content:
        "Programme and project management with built-in stage-gate governance, RAAIDD logs, resource management, and the APTIM-Solutions Input Management Framework.",
    },
  ];
}

export async function loader({ request }: Route.LoaderArgs) {
  const userId = await getUserId(request);
  return { authenticated: !!userId };
}

export default function Home({ loaderData }: Route.ComponentProps) {
  return <LandingPage authenticated={loaderData.authenticated} />;
}
